import { createFileRoute } from "@tanstack/react-router";
import type { FermentationGroupId } from "@brewbase/db/types";
import { AftercarePage } from "@/features/fermentation-journal/components/aftercare";

export const Route = createFileRoute(
  "/fermentations/$group_id/aftercare/weights",
)({
  component: WeightsPage,
});

function WeightsPage() {
  const { group_id } = Route.useParams();
  return (
    <div className="max-w-4xl">
      <AftercarePage groupId={group_id as unknown as FermentationGroupId} />
    </div>
  );
}
